const env = process.env as {
  [x: string]: string,
};

export const ENVIRONMENT = env.REACT_APP_ENV;

export default null;
